
import WrapComponents from "../../components/WrapComponents.vue";

import { mapState } from "vuex";
import { getProvinces } from "~/utils/staticData";
import { isMobile } from "../../utils/common";
export default {
  name: "benchmark",
  layout: "root",
  components: { WrapComponents },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      range: "",
      page: "",
      mobile: false,

      yearSelected: 2025,

      searchTypeData: [
        { name: "Trường", id: "schoolName" },
        { name: "Ngành học", id: "majorName" },
      ],
      searchType: "majorName",
      provinceId: "all",
      pagination: {},
      tabsData: [
        {
          id: "all",
          title: "Tất cả",
        },
        {
          id: "15-18",
          title: "15-18 điểm",
        },
        {
          id: "18-22",
          title: "18-22 điểm",
        },
        {
          id: "22-25",
          title: "22-25 điểm",
        },
        {
          id: "25-30",
          title: "25-30 điểm",
        },
      ],

      columns: [
        {
          width: 76,
          align: "center",
          dataIndex: "key",
          key: "key",
          slots: { title: "key" },
        },
        {
          title: "Tên ngành, mã ngành",
          dataIndex: "specialty",
          key: "specialty",
          width: 240,
          scopedSlots: { customRender: "majors" },
        },
        {
          title: "Trường đào tạo",
          dataIndex: "school_name",
          key: "school_name",
          scopedSlots: { customRender: "school_name" },
          width: 240,
        },
        {
          title: "Địa điểm",
          width: 200,
          dataIndex: "address_default_province",
          key: "address_default_province",
        },
        {
          title: "Điểm chuẩn",
          dataIndex: "benchmark",
          key: "benchmark",
          width: 100,
          align: "left",
        },
        {
          title: "Văn bằng",
          dataIndex: "method_content",
          key: "method_content",
          width: 100,
          align: "left",
        },
        {
          title: "Tổ hợp xét tuyển",
          dataIndex: "subject",
          key: "subject",
          width: 160,
          scopedSlots: { customRender: "subject" },
        },
      ],
    };
  },
  computed: {
    ...mapState("Major", ["listBenchmark", "benchmarkLoading"]),
    provinces() {
      const provices2 = getProvinces("array");
      return provices2;
    },

    getPagination() {
      let pagination = {
        current: 1,
        total: 0,
      };

      if (!this.benchmarkLoading && this.listBenchmark.metadata) {
        pagination = {
          current: this.listBenchmark.metadata.current_page
            ? this.listBenchmark.metadata.current_page
            : 1,
          total: this.listBenchmark.metadata.total_items,
        };
      }
      return pagination;
    },
  },
  async mounted() {
    this.mobile = isMobile();
    this.range = this.$route.query.range;
    this.yearSelected = +this.$route.query.year || 2025;
    parseInt(this.$route.query.province_id)
      ? (this.provinceId = this.$route.query.province_id)
      : (this.$route.query.province_id = "all");

    await this.getPaginationData();
  },

  watch: {
    "$route.query.range"() {
      this.range = this.$route.query.range;
      this.searchInput = "";
    },
    "$route.query.province_id"(newValue, oldValue) {
      this.provinceId = newValue ? newValue : "all";
    },

    "$route.query"(newValue, oldValue) {
      //Change value select whenever province_id change
      // if(newValue.province_id && parseInt(newValue.province_id)){
      //   this.provinceId = p
      // }
      this.getPaginationData();
    },
  },
  methods: {
    handleDisplayItemPerPage(metadata) {
      const currentPage = metadata.current_page;
      const pageSize = metadata.page_size;
      const totalItems = metadata.total_items;

      const startItem = (currentPage - 1) * pageSize + 1;
      const endItem = Math.min(currentPage * pageSize, totalItems);

      return `Hiển thị ${startItem} đến ${endItem} của tất cả ${metadata.total_items} kết quả`;
    },
    handleYearChange(value) {
      this.range = "all";
      this.searchInput = "";
      this.yearSelected = value;
      let query = {
        range: "all",
        year: value,
      };
      this.$router.push({ path: "/diem-chuan", query });
    },
    handleSearchTypeChange(value) {
      this.searchType = value;
    },
    handleFilterLocation(value) {
      let query = { ...this.$route.query };
      query.page = "1";
      // parseInt(value) && (query.province_id = value);
      this.provinceId = parseInt(value) ? value : "all";
      query.province_id = parseInt(value) ? value : "all";

      this.$router.push({ path: "/diem-chuan", query });
    },
    handleTableChange(pagination) {
      let query = { ...this.$route.query };

      query.page = pagination.current;

      this.$router.push({ path: "/diem-chuan", query });
    },
    handleSearch(value) {
      console.log({ value });
      let query = { ...this.$route.query };
      if (this.searchType === "schoolName") {
        query.schoolName = value;
        delete query.majorName;
      } else if (this.searchType === "majorName") {
        query.majorName = value;
        delete query.schoolName;
      }
      if (value.length === 0) {
        delete query.schoolName;
        delete query.majorName;
      }
      query.page = "1";
      this.$router.push({ path: "/diem-chuan", query });
    },
    async getPaginationData() {
      let range = this.$route.query.range;
      let provinceId = this.$route.query.province_id || "";
      if (provinceId === "all") {
        provinceId = "";
      }
      // let queries = {
      //   filter_by_range: "",
      //   page_size: 10,
      //   page: this.$route.query.page || 1,
      //   school_name: this.$route.query.school_name || "",
      //   major_name: this.$route.query.major_name || "",
      //   year: this.$route.query.year || 2022,
      //   province_id: provinceId,
      //   order: "desc",
      //   sort_by: "id",
      // };
      let queries = {
        ...this.$route.query,
        page: this.$route.query.page || 1,
        page_size: 10,
        order: "desc",
        sort_by: "id",
        province_id: provinceId,
      };
      // console.log({ queries });
      switch (range) {
        case "all":
          queries.filter_by_range = "";
          break;
        case "15-18":
          queries.filter_by_range = "15-18";
          break;
        case "18-22":
          queries.filter_by_range = "18-22";
          break;
        case "22-25":
          queries.filter_by_range = "22-25";
          break;
        case "25-30":
          queries.filter_by_range = "25-30";
          break;
        default:
          queries.filter_by_range = "all";
          break;
      }

      await this.$store.dispatch("Major/getListBenchmark", queries);
      this.searchInput = "";
    },
  },
};
